<template>
<div class="p-t-md p-b-md inner-content">
  {{/** 订单类别 */}}
  <div class="bg-gray-5 p-a">
    我的订单：
    <span v-for="(t, index) in types"
      :class="{'order-list-type': true, 'active': index === activeType}" @click="changeActiveType(index)">{{t}}</span>
  </div>
  {{/** 订单列表 */}}
  <div v-for="o in orders" class="order-item">
    <div class="order-header">
      订单编号：{{o.orderNo}} <span class="m-l-lg">下单时间：{{o.createdTime}}</span>
    </div>
    <div class="bg-white clearfix o-item-wrp">
      <div class="o-3-1 p-a-20">
        <img class="o-img pull-left" :src="o.caseInfo && o.caseInfo.coverImgUrl" >
        <div class="o-info">
          <div class="o-header text-elli">{{o.caseInfo && o.caseInfo.title}}</div>
          <div class="o-desc text-elli">{{o.caseInfo && o.caseInfo.description}}</div>
        </div>
      </div>
      <div class="o-3-1 p-a-20 text-center o-price-wrp">
        定金：<span class="text-price">￥{{o.price / 100 || ''}}</span>
      </div>
      <div class="o-3-1 p-a-20 text-right">
        <div style="height: 40px;" v-if="!o.isRefund && (o.refund === 0 || o.refund === 3)"><button v-if="o.status === 1 || o.status === 2" class="c-b c-b-refund" @click="applyRefund(o)">申请退款</button></div>
        <div class="m-t-20 text-medium" v-if="!o.isRefund && o.refund === 0 || (o.refund === 3 && o.status === 2) && !(o.refund === 1 && o.status === 2) && o.refundStatus !== 1">订单状态：{{orderStatus[o.status]}}</div>
        <div class="m-t-20 text-medium" v-if="o.refund !== 0 && !(o.refund === 3 && o.status === 2)">订单状态：{{refundStatus[o.refund]}}</div>
        <div class="m-t-20 text-medium" v-if="o.refundStatus === 1">订单状态：退款中</div>
      </div>
    </div>
  </div>
  <div class="hint" v-if="showHint">{{hintMsg}}</div>
  {{/** 分页 */}}
  <pagination :pagination="pagination" :callback="loadData" :options="paginationOptions"></pagination>
</div>
</template>
<script>
import toastr from 'mini-toastr';
import pagination from '../reusable/Pagination';
import orderService from '../service/order';
import { mixinPager } from '../reusable/pager';
import { ORDER_STATUS, REFUND_STATUS } from '../constants';

const vm = {
  name: 'OrderList',
  mainService: orderService,
  dataKey: 'orders',
  data() {
    return {
      types: ['全部订单', '待接单', '已接单', '已完成'],
      activeType: 0,
      orders: [],
      orderStatus: ORDER_STATUS,
      refundStatus: REFUND_STATUS,
      params: {
        status: -1,
      },
      showHint: false,
      hintMsg: '没有相关订单信息',
    };
  },
  components: {
    pagination,
  },
  methods: {
    changeActiveType(index) {
      this.activeType = index;
      if (index === 0) {
        this.params.status = -1;
      } else if (index === 3) {
        this.params.status = 5;
      } else {
        this.params.status = index;
      }
      this.pagination.current_page = 1;
      this.loadData();
    },
    applyRefund(order) {
      orderService.applyRefund(order.id).then(() => {
        this.$set(order, 'isRefund', true);
        this.$set(order, 'refundStatus', 1);
      }, () => {
        toastr.warn('申请退款失败');
      });
    },
  },
  watch: {
    orders: {
      handler(list) {
        if (list.length === 0) {
          this.showHint = true;
        } else {
          this.showHint = false;
        }
      },
      deep: true,
    },
  },
};
mixinPager(vm);
export default vm;
</script>
<style>
.order-list-type {
  margin-left: 20px;
  cursor: pointer;
}
.order-list-type.active {
  color: #ba882a;
}
.order-item {
  margin-top: 30px;
  border: solid 1px #e1e1e1;
}
.order-header {
  padding-left: 20px;
  background-color: #f4f4f4;
  height: 40px;
  line-height: 40px;

}
.o-3-1 {
  float: left;
  width: 33.33%;
  box-sizing: border-box;
  border-right: 1px solid #e1e1e1;
  height: 100%;
}
.clearfix > .o-3-1:last-child {
  border-right: 0 none;
}
.o-img {
  height: 72px;
  width: 72px;
}
.o-info {
  margin-left: 97px;
}
.o-header {
  color: #252525;
  font-size: 14px;
}
.o-desc {
  color: #787878;
  font-size: 12px;
  margin-top: 25px;
}
.o-item-wrp {
  height: 112px;
}
.o-price-wrp {
  line-height: 72px;
}
.c-b.c-b-refund {
  height: 40px;
  border-radius: 4px;
  background-color: #ba882a;
  padding: 0 45px;
  color: #ffffff;
  font-weight: 600;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// OrderList.vue?5336733c